import { __rest } from "tslib";
import * as React from 'react';
import DatePicker from '../date-picker';
import useBuriedPoint from '../_util/hooks/useBuriedPoint';
import warning from '../_util/warning';
const { TimePicker: InternalTimePicker, RangePicker: InternalRangePicker } = DatePicker;
const RangePicker = React.forwardRef((props, ref) => {
    const { dropdownClassName, popupClassName } = props;
    return (React.createElement(InternalRangePicker, Object.assign({}, props, { dropdownClassName: dropdownClassName, popupClassName: popupClassName, picker: "time", mode: undefined, ref: ref })));
});
const TimePicker = React.forwardRef((_a, ref) => {
    var { addon, renderExtraFooter, popupClassName, dropdownClassName } = _a, restProps = __rest(_a, ["addon", "renderExtraFooter", "popupClassName", "dropdownClassName"]);
    useBuriedPoint('TimePicker');
    const internalRenderExtraFooter = React.useMemo(() => {
        if (renderExtraFooter) {
            return renderExtraFooter;
        }
        if (addon) {
            warning(false, 'TimePicker', '`addon` is deprecated. Please use `renderExtraFooter` instead.');
            return addon;
        }
        return undefined;
    }, [addon, renderExtraFooter]);
    return (React.createElement(InternalTimePicker, Object.assign({ dropdownClassName: dropdownClassName, popupClassName: popupClassName }, restProps, { mode: undefined, ref: ref, renderExtraFooter: internalRenderExtraFooter })));
});
if (process.env.NODE_ENV !== 'production') {
    TimePicker.displayName = 'TimePicker';
}
TimePicker.RangePicker = RangePicker;
export default TimePicker;
